// ============================================================================
// AUDIT CORRECTIONS (2026-10-14) — missed check-in / no-show on a closed date
// ============================================================================
// crs.Core.DTOs.NightAuditModule.AuditCorrectionDtos. Kept in the audit log,
// not a table of their own (BR-AUD-001).

import type { QuickCheckInRequest } from './checkin.types';

export type AuditCorrectionKind = 'MISSED_CHECK_IN' | 'LATE_NO_SHOW' | 'NIGHTS_POSTED';

export const AUDIT_CORRECTION_LABEL: Record<string, string> = {
  MISSED_CHECK_IN: 'Missed check-in',
  LATE_NO_SHOW: 'No-show',
  NIGHTS_POSTED: 'Nights posted',
};

export interface UnresolvedArrival {
  bookingId: string;
  bookingNumber: string;
  guestName?: string | null;
  guestPhone?: string | null;
  bookingSource?: string | null;
  partyName?: string | null;
  checkInDate: string;
  checkOutDate: string;
  numNights: number;
  totalRooms: number;
  statusCode: string;
  statusName?: string | null;
  advanceReceived: number;
  /** The booked check-out date has passed — a missed check-in also departs on it. */
  stayOver: boolean;
  /** Arrival date closed by night audit; false = still open while the audit catches up. */
  dateClosed: boolean;
}

export interface AuditCorrectionEntry {
  eventId: number;
  at: string;
  userName?: string | null;
  bookingId: string;
  bookingNumber?: string | null;
  kind: AuditCorrectionKind | string;
  reason?: string | null;
  arrivedOn?: string | null;
  departedOn?: string | null;
  nightsPosted: number;
  amountPosted: number;
  failures: string[];
}

export interface AuditCorrections {
  propertyId: string;
  businessDate: string;
  closedThrough?: string | null;
  openDate: string;
  startDate?: string | null;
  unresolved: UnresolvedArrival[];
  recent: AuditCorrectionEntry[];
}

export interface RecordMissedCheckInRequest {
  checkIn: QuickCheckInRequest;
  reason: string;
  /** "HH:mm:ss" — departure time on the booked check-out date (default 12:00). */
  departureTime?: string;
}

export interface AuditCorrectionResult {
  bookingId: string;
  kind: AuditCorrectionKind | string;
  arrivedOn?: string | null;
  departedOn?: string | null;
  nightsPosted: number;
  amountPosted: number;
  failures: string[];
  message: string;
}
